import React from 'react';

function TBody(props: any) {
  return <tbody {...props} />;
}

export default TBody;
